import { render } from "./ArticleTemplate.vue?vue&type=template&id=a0325f1c&scoped=true"
import script from "./ArticleTemplate.vue?vue&type=script&lang=js"
export * from "./ArticleTemplate.vue?vue&type=script&lang=js"

import "./ArticleTemplate.vue?vue&type=style&index=0&id=a0325f1c&scoped=true&lang=css"

import exportComponent from "E:\\新建文件夹\\简策demo\\V策财经\\V策财经web-push\\vce-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a0325f1c"]])

export default __exports__